import React from 'react'
import NumberFormat from 'react-number-format'
import { Link } from 'react-router-dom';

export const slotFormat = (cell, index, total) => {
  if (index === total) {
    return 'Finish'
  }

  return cell + 1
}

export const withSmallerFormat = (cell, key, small) => {
  return <div key={key}>
    {cell} - <i>
      <small>{small}</small>
    </i>
  </div>
}

export const money = (cell) => {
  if (cell === null || cell === undefined)
    return '--'

  return <NumberFormat
    value={cell.toFixed(2)}
    displayType="text"
    thousandSeparator=","
    decimalSeparator="."
    prefix={'$ '}
    decimalScale={2}
    fixedDecimalScale={true}
  />
}

export const percent = (cell) => {
  if (cell === null)
    return 'N/A'

  return <NumberFormat
    value={cell * 100}
    displayType="text"
    decimalSeparator="."
    suffix={'%'}
    decimalScale={0}
    fixedDecimalScale={true}
  />
}

export const numberFormat = (cell, percent) => {
  if (percent && typeof percent === 'number') {
    return <span>
      <NumberFormat value={cell} displayType="text" thousandSeparator={true} /> - {percent}%
    </span>
  }

  return <NumberFormat value={cell} displayType="text" thousandSeparator={true} />
}

export const getUniqueImpressionsCount = (item) => {
  return item.slots.reduce((acc, cur) => acc + cur.unique, 0)
}

export const formatPage = (id, row) => {
  if (row.value === 0)
    return "Finish page"

  return <Link
    to={`/path/pages/${id}`}
    className='text-truncate'
    style={{ width: '160px' }}
  >
    #{id} - {row.name}
  </Link>
}

export const formatPath = (row) => {
  return <Link
    to={`/path/paths/${row.value}`}
    className='truncate w-40 twy-text-accent hover:underline'
  >
    #{row.value} - {row.name}
  </Link>
}

